import React from 'react';
import PropTypes from 'prop-types';
import { __ } from 'i18n-for-browser';

const translate = (txt, translateItem) => {
  if (typeof txt === 'string' && translateItem) {
    return __(txt);
  }
  return txt;
};

class Table extends React.Component {
  static propTypes = {
    headColor: PropTypes.string,
    headTextColor: PropTypes.string,
    head: PropTypes.array,
    body: PropTypes.array.isRequired,
    foot: PropTypes.array,
    translate: PropTypes.bool,
    className: PropTypes.string,
  };

  static defaultProps = {
    head: [],
    foot: [],
    className: '',
    translate: true,
  };

  render() {
    return (
      <div className={`tableWrapper${!this.props.foot.length ? ' no-footer' : ''}${!this.props.head.length ? ' no-header' : ''}`}>
        {
          this.props.head.length
          ? (
              <div className={`thead-border${this.props.headColor ? ` thead-color--${this.props.headColor}` : ''}`}>
                <div className={`background`} />
              </div>
            )
          : null
        }
      <div className={'tbody-border'}>
        <div className={'background'} />
      </div>
      {
        this.props.foot.length
        ? (
            <div className={'tfooter-border'}>
              <div className={'background'} />
            </div>
          )
        : null
      }
      <table className={this.props.className} cellSpacing={'0'} cellPadding={'0'}>
        {
          this.props.head.length
          ? (
              <thead className={`${this.props.headTextColor ? `thead-TextColor--${this.props.headTextColor}` : ''}`}>
                <tr>
                  {this.props.head.map((headerItem, i) => (<th key={i}>{translate(headerItem, this.props.translate)}</th>))}
                </tr>
              </thead>
            )
         : null
        }
        <tbody>
        {this.props.body.map((bodyItem, y) => {
          if (!bodyItem) return null;
          return (
            <tr key={y}>
              {bodyItem.map((item, i) => (<td key={i}>{translate(item, this.props.translate)}</td>))}
            </tr>
          );
        })}
        </tbody>
        {
          this.props.foot.length
          ? (
              <tfoot>
                <tr>
                  {this.props.foot.map((footItem, i) => (<td key={i}>{translate(footItem, this.props.translate)}</td>))}
                </tr>
              </tfoot>
            )
          : null
        }
      </table>
      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/elements/Table.js